import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

const Loader = ({ isLoading, spinner, style, children }) => {
  if(isLoading) {
    if(spinner) {
      return <CircularProgress size={30} />;
    }

    return(
      <Box display="flex" justifyContent="center" alignItems="center" p={1} style={style}>
        <CircularProgress size={30} />
      </Box>
    );
  }

  return children || null;
}

export default Loader;